import { CommonModule } from "@angular/common";
import { NgModule, ModuleWithProviders, InjectionToken  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import {DndModule} from 'ng2-dnd';
import { SmartFormLibService } from './smart-form-lib.service';
import { SmartFormLibComponent } from './smart-form-lib.component';
import { WizardComponent } from './wizard/wizard.component';
import { InputControlComponent } from './input-control/input-control.component';
import { AudioControlComponent } from './audio-control/audio-control.component';
import { VariableFilterPipe } from './pipes/variable-filter.pipe';

// first define an interface for our configuration
export interface EnvConfig {
  api: string;
}

// then define injectionToken
export const EnvConfigService = new InjectionToken<EnvConfig>(
  'EnvConfig'
);

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    DndModule.forRoot()
  ],
  declarations: [SmartFormLibComponent, WizardComponent, InputControlComponent, AudioControlComponent, VariableFilterPipe],
  exports: [SmartFormLibComponent]
})
export class SmartFormLibModule { 
  static forRoot(config: EnvConfig): ModuleWithProviders {
    return {
      ngModule: SmartFormLibModule,
      providers: [
        SmartFormLibService,
        {
          provide: EnvConfigService,
          useValue: config
        }
      ]
    };
  }
}
